import { SubscriptionResponse } from "../../interfaces/subscriptions.interface";

const ACTIVE_STATUSES = new Set(["active", "trial"]);
const LEGACY_PROCESSORS = new Set(["clickbank", "recurly", "paykickstart"]);

const isSubscriptionCurrentlyActive = (
  subscription: NonNullable<SubscriptionResponse["subscriptions"]>[number],
  now = new Date()
): boolean => {
  if (!ACTIVE_STATUSES.has(subscription.status)) {
    return false;
  }

  return !subscription.endDate || new Date(subscription.endDate).getTime() > now.getTime();
};

const getBillingProcessor = (
  subscriptions?: SubscriptionResponse,
  fallbackProcessor?: string | null
): string | null => {
  const subscriptionList = subscriptions?.subscriptions ?? [];
  const activeSubscriptions = subscriptionList.filter((subscription) => isSubscriptionCurrentlyActive(subscription));
  const primaryActiveSubscription = activeSubscriptions.find((subscription) => subscription.primary);

  if (primaryActiveSubscription) {
    return primaryActiveSubscription.processor;
  }

  if (activeSubscriptions.length > 0) {
    return activeSubscriptions[0].processor;
  }

  // Once a legacy subscription has expired, move the customer to Paddle instead
  // of sending them back to the old provider's billing portal.
  if (
    subscriptionList.some((subscription) => LEGACY_PROCESSORS.has(subscription.processor)) ||
    (fallbackProcessor && LEGACY_PROCESSORS.has(fallbackProcessor))
  ) {
    return "paddle";
  }

  const primarySubscription = subscriptionList.find((subscription) => subscription.primary);
  if (primarySubscription) {
    return primarySubscription.processor;
  }

  if (subscriptionList.length > 0) {
    return subscriptionList[0].processor;
  }

  return fallbackProcessor ?? null;
};

export { isSubscriptionCurrentlyActive };
export default getBillingProcessor;
